import axios from "axios";
import { getUserInfo } from "../db/users";

const API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;

async function authenticate(mode, email, password) {
  const url = `https://identitytoolkit.googleapis.com/v1/accounts:${mode}?key=${API_KEY}`;

  const response = await axios.post(url, {
    email: email,
    password: password,
    returnSecureToken: true,
  });

  const token = response.data.idToken;
  const userInfo = await getUserInfo(response.data.localId, token);

  let userName = null;
  let role = null;

  if (userInfo.data != null) {
    userName = userInfo.data.name;
    role = userInfo.data.role;
  }

  const responseData = {
    userName,
    role,
    userId: response.data.localId,
    token,
    refreshToken: response.data.refreshToken,
    expiresIn: response.data.expiresIn,
  };

  return createAuthResponse(responseData);
}

export function createUser(email, password) {
  return authenticate("signUp", email, password);
}

export function login(email, password) {
  return authenticate("signInWithPassword", email, password);
}

export async function passwordReset(email) {
  const url = `https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=${API_KEY}`;
  const response = await axios.post(
    url,
    {
      requestType: "PASSWORD_RESET",
      email,
    },
    {
      headers: {
        "X-Firebase-Locale": "es-MX",
      },
    }
  );
  return response;
}

export async function exchangeRefreshToken(refreshToken, userId) {
  const url = `https://securetoken.googleapis.com/v1/token?key=${API_KEY}`;
  let response = undefined;
  try {
    response = await axios.post(url, {
      grant_type: "refresh_token",
      refresh_token: refreshToken,
    });
  } catch (error) {
    console.log("error in post call to refresh", error);
  }

  const token = response.data.id_token;

  const userInfo = await getUserInfo(userId, token);

  const userName = userInfo.data.name;
  const role = userInfo.data.role;

  const responseData = {
    userId: userId,
    userName: userName,
    role: role,
    token: response.data.id_token,
    refreshToken: response.data.refresh_token,
    expiresIn: response.data.expires_in,
  };

  return createAuthResponse(responseData);
}

function createAuthResponse({
  token,
  refreshToken,
  expiresIn,
  userName,
  role,
  userId,
}) {
  let expireDate = new Date();
  expireDate.setSeconds(expireDate.getSeconds() + expiresIn);
  const expireString = expireDate.toString();
  const responseInfo = {
    token,
    refreshToken,
    expireDate: expireString,
    userName,
    role,
    userId,
  };
  return responseInfo;
}

export function completeCardId(cardId) {
  if (cardId.length < 7) {
    cardId = cardId.padEnd(7, "0");
  }
  return cardId;
}
